import React, {Component} from 'react'

// SITE VARIABLES
let userType = "";
let imagePath = "https://s3-sa-east-1.amazonaws.com/blues-fisioterapia-user-upload/images";
let profileImage;
let appointmentPrice = 79.90;
let user = null;
let clinic = {};

let homeAppointmentData = null;

const civilStates = ["Solteiro", "Casado", "Divorciado", "Viúvo", "Outro"];

let get = (endpoint, callback) =>{
  fetch(server.address + "/" + endpoint,{
    method:"GET",
    headers:{
        'Accept': 'application/json',
        'Content-Type':'application/json'
    },
}).then(response => response.json().then(data =>{
    callback(data)
}))}

let post = (endpoint, data, callback) =>{
  fetch(server.address + "/" + endpoint,{
    method:"POST",
    headers:{
        'Accept': 'application/json',
        'Content-Type':'application/json'
    },
    body: JSON.stringify(data)
}).then(response => response.json().then(data =>{
    if(callback) callback(data)
}))}

let put = (endpoint, data, callback) =>{
  fetch(server.address + "/" + endpoint,{
    method:"PUT",
    headers:{
        'Accept': 'application/json',
        'Content-Type':'application/json'
    },
    body: JSON.stringify(data)
}).then(response => response.json().then(data =>{
    if(callback) callback(data)
}))}

// HELPERS

let fullDateString = (date) =>{
  if(date == null) return "";
  
  const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

  let dateSplit;

  if(date instanceof(Date)){
    dateSplit = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
    return dateSplit[2] + " de " + months[parseInt(dateSplit[1] - 1)] + ", " + dateSplit[0];
  }

  const splitted = date.split(" ");
  dateSplit = splitted[0].split("-");

  const dateString = dateSplit[2] + " de " + months[parseInt(dateSplit[1] - 1)] + ", " + dateSplit[0];

  if(splitted.length == 1) return dateString
  else return dateString + " " + splitted[1].slice(0,5);
}

let formatCpf = (cpf) =>{
  return cpf.replace(/\./g, '').replace(/\-/,'');
}

// MEDIA

let getMedia = (id, object) =>{
  let newMedia = [];

  get("appointments/" + id + "/media", (data) =>{
      console.log(data)
      newMedia = [...newMedia, ...data.map((pic) => {
          let split = pic.split(".");
          let type = split[split.length - 1];
          let link = 'https://s3-sa-east-1.amazonaws.com/blues-fisioterapia-user-upload/' + pic
          let component;
          if(type == "mp4")
              component =
                      <video key={pic} width="60" height="60" autoPlay class="bdrs-2">
                              <source src={link} alt=""/>
                              Your browser does not support video
                      </video>
          else
              component = <img key={pic} class="bdrs-2  w-100p" src={link} alt=""/>
      
          return <a href={link}>{component}</a>
      })]

      object.setState({pictures:[...object.state.pictures, ...newMedia]});
  });
}

// LOAD

let load_appointments = (type,id,callback) =>{
  fetch(server.address + "/" + type + "/appointments/"+localStorage.getItem("id"),{
      method:"GET",
      headers:{
          'Accept': 'application/json',
          'Content-Type':'application/json'
      },
  }).then(response => response.json().then(data =>{
      callback(data["appointments"])
  }))
}

let load_clinic = (callback) => {
  fetch(server.address + "/clinics/"+localStorage.getItem("id"),{
      method:"GET",
      headers:{
          'Accept': 'application/json',
          'Content-Type':'application/json'
      },
  }).then(response => response.json().then(data =>{
      callback(data)
  }))
}

let load_clinic_patients = (callback) => {
  fetch(server.address + "/clinics/"+localStorage.getItem("id") + "/patients",{
      method:"GET",
      headers:{
          'Accept': 'application/json',
          'Content-Type':'application/json'
      },
  }).then(response => response.json().then(data =>{
      callback(data)
  }))
}

let load_record = (id,callback) =>{
  fetch(server.address + "/records/"+id,{
      method:"GET",
      headers:{
          'Accept': 'application/json',
          'Content-Type':'application/json'
      },
  }).then(response => response.json().then(data =>{
      callback(data)
  }))
}

// REGISTER

let register_clinic = (data,success,error) => {
  // Adjusting data
  data["cep"] = data["cep"].replace(/\-/g,'')
  data["telephone"] = data["telephone"].replace(/\_/,'').replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'')
  data["secretaryCpf"] = data["secretaryCpf"].replace(/\./g, '').replace(/\-/,'')
  data["street"] = data["street"].normalize('NFD').replace(/[\u0300-\u036f]/g, "")
  data["name"] = data["name"].normalize('NFD').replace(/[\u0300-\u036f]/g, "")
  data["secretaryName"] = data["secretaryName"].normalize('NFD').replace(/[\u0300-\u036f]/g, "")

  // Creating and retrieving the response

  post("clinics", data, (resp)=>{
    if(resp.id){
      success()
    }else{
      error(resp.message)
    }
  });
}


let register_secretary = (data,success,error) => {
  // Adjusting data

  data["c_cep"] = data["c_cep"].replace(/\-/g,'')
  data["c_telephone"] = data["c_telephone"].replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'')

  data["cpf"] = data["cpf"].replace(/\./g, '').replace(/\-/,'')
  data["telephone"] = data["telephone"].replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'')

  data["d_cpf"] = data["d_cpf"].replace(/\./g, '').replace(/\-/,'')
  data["d_telephone"] = data["d_telephone"].replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'')

  // Creating and retrieving the response

  fetch(server.address + "/secretaries",{
      method:"POST",
      headers:{
          'Accept': 'application/json',
          'Content-Type':'application/json'
      },
      body: JSON.stringify(data)
  }).then(response => response.json().then(data=>{
    if(data.id){
      success()
    }else{
      error(data.message)
    }
  }))
}

let register_record = (data,success,error) => {
  // Creating and retrieving the response
  data["cpf"] = data["cpf"].replace(/\./g, '').replace(/\-/,'')
  data["telephone"] = data["telephone"].replace(/\_/,'').replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'')
  if(data["cep"]){
	data["cep"] = data["cep"].toString().replace(/\-/g,'')
  }
  fetch(server.address + "/patients/" + data.patient_id,{
    method:"PUT",
    headers:{
        'Accept': 'application/json',
        'Content-Type':'application/json'
    },
    body: JSON.stringify(data)
})

  fetch(server.address + "/records",{
      method:"POST",
      headers:{
          'Accept': 'application/json',
          'Content-Type':'application/json'
      },
      body: JSON.stringify(data)
  }).then(response => response.json().then(data=>{
    if(data.id){
      success()
    }else{
      error(data.message)
    }
  }))
}

let register_fisioterapist = (data,success,error) => {
  // Adjusting data
  data["cpf"] = data["cpf"].replace(/\./g, '').replace(/\-/,'')
  data["telephone"] = data["telephone"].replace(/\_/,'').replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'')
  data["cep"] = data["cep"].replace(/\-/g,'')
  // Creating and retrieving the response

  fetch(server.address + "/fisioterapists",{
      method:"POST",
      headers:{
          'Accept': 'application/json',
          'Content-Type':'application/json'
      },
      body: JSON.stringify(data)
  }).then(response => response.json().then(data=>{
    if(data.id){
      success()
    }else{
      error(JSON.stringify(data.message))
    }
  }))
}

let register_patient = (data,success,error) => {
  // Adjusting data
  data["cpf"] = data["cpf"].replace(/\./g, '').replace(/\-/,'')
  data["telephone"] = data["telephone"].replace(/\_/,'').replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'')
  // Creating and retrieving the response

  fetch(server.address + "/patients",{
      method:"POST",
      headers:{
          'Accept': 'application/json',
          'Content-Type':'application/json'
      },
      body: JSON.stringify(data)
  }).then(response => response.json().then(data=>{
    if(data.id){
      success(data)
    }else{
      error(JSON.stringify(data.message))
    }
  }))
}

// APPOINTMENTS

let create_appointment = (data, callback = (data)=>{}) => {
  fetch(server.address + '/appointments',{
    method:"POST",
    headers:{
        'Accept': 'application/json',
        'Content-Type':'application/json'
    },
    body: JSON.stringify(data)
  }).then(response => response.json().then(app =>{
      callback(app);
  }))
}

let charge_appointment = (id,success = () => {}, error = (message) => {}) => {
  fetch(server.address + "/appointments/charge/"+id,{
    method:"GET",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then(response => response.json().then(data => {
    if(data.success){
      success();
    }else{
      error(data.message);
    }
  }))
}

let funcs = {
  get:get,
  post:post,
  put:put,
  getMedia:getMedia,
  fullDateString:fullDateString,
  formatCpf:formatCpf
}

let homol_server = {
  address: "https://blues-server.herokuapp.com",
  register_secretary: register_secretary,
  register_clinic: register_clinic,
  register_fisioterapist: register_fisioterapist,
  load_appointments: load_appointments,
  load_clinic: load_clinic,
  create_appointment: create_appointment,
  load_record: load_record,
  register_record: register_record,
  charge_appointment: charge_appointment,
  create_patient:register_patient
}

let home_server = {
  address: "http://127.0.0.1:5000",
  register_secretary: register_secretary,
  register_clinic: register_clinic,
  register_fisioterapist: register_fisioterapist,
  load_appointments: load_appointments,
  load_clinic: load_clinic,
  create_appointment: create_appointment,
  load_record: load_record,
  register_record: register_record,
  charge_appointment: charge_appointment,
  create_patient:register_patient
}

let server = homol_server

export default {...server, ...funcs, userType, user, clinic, profileImage, imagePath, appointmentPrice, civilStates, homeAppointmentData}



// WEBPACK FOOTER //
// ./src/server.js